import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { map } from 'rxjs/operators';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class MyteamsService {

  constructor(private _utilsService: UtilsService) { }

  getContestListing(user_id, type, lgIndex, tIndex, live, game_id, playersBool, search = null,season=null) {
    let url = `${environment.boxScoreUrl}/contestListing2/${user_id}/${type}/${lgIndex}/${tIndex}/${live}/${game_id}/${(playersBool) ? '1' : '0'}${(search == null) ? '' : '/' + search}`;
    if(live == 'history'){
      url = `${environment.boxScoreUrl}/api/front/historyContestListing?type=${type}&lgIndex=${lgIndex}&tIndex=${tIndex}&live=${live}&game_id=${game_id}&players=${playersBool ? '1' : '0'}${search ? `&search=${search}` : ''}&season=${season}`;
    }
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }

  getContestPlayers(slug, auto = 0, entryId = 0,seasonId = 0) {
    let query = (auto) ? '?auto=1&entryId='+entryId+'' : '?a=1';
    if(seasonId) query = query+'&season='+seasonId;
    const url = `${environment.boxScoreUrl}/getMyTeam/${slug}${query}`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }
  getSwapPlayerData(league_id,user_id,session_id) {
    const url = `${environment.boxScoreUrl}/getPlayersData/${league_id}/${user_id}/${session_id}`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }
  getSwappedPlayers(league_id,swap_uuid,session_id) {
    const url = `${environment.phpApiUrl}/swapPlayers/getSwappedPlayers/${environment.DRAFT_ACCESS_TOKEN}/${league_id}/${swap_uuid}/${session_id}`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }
  updateSwapPlayer(post_data) {
    const url = `${environment.phpApiUrl}/player/updateLeaguePlayers/`;
    return this._utilsService.putRequest(url, post_data, null, 'content-type-json');
  }
  updateMultiSwapPlayer(post_data) {
    const url = `${environment.phpApiUrl}/fantasyLeague/updateMultiSwapLeaguePlayers/`;
    return this._utilsService.postRequest(url, post_data, null, 'content-type-json');
  }

  getContestPlayersWeek(slug, week,seasonId = 0) {
    let url = `${environment.boxScoreUrl}/getMyTeam/${slug}/-1/0/0/${week}`;
    if(seasonId) url = url+'?season='+seasonId;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }

  getContestPlayersMove(slug, player_id) {
    const url = `${environment.boxScoreUrl}/getMyTeam/${slug}/-1/${player_id}`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }

  expandTour(lgm_ids, search,seasonId = 0) {
    let url = `${environment.boxScoreUrl}/tourListing`
    if(seasonId) url = url+'?season='+seasonId;
    return this._utilsService.postRequest(url, {lgm_ids, search}, null, 'content-type-json');
  }

  liveRefresh(lgms, tours, user_id) {
    return this._utilsService.postRequest(`${environment.boxScoreUrl}/liveRefresh`, {lgms, tours, user_id}, null, 'content-type-json');
  }
  addPlayerToSwap(post_data) {
    return this._utilsService.postRequest(`${environment.phpApiUrl}/swapPlayers/addToSwapQueue`, post_data, null, 'content-type-json');
  }
  getMultiSwapLeagues(post_data) {
    return this._utilsService.postRequest(`${environment.phpApiUrl}/fantasyLeague/getMultiSwapLeaguePlayers`, post_data, null, 'content-type-json');
  }
  getOtherLeaguesForMultiSwap(post_data) {
    return this._utilsService.postRequest(`${environment.phpApiUrl}/fantasyLeague/getOtherLeaguesForMultiSwap`, post_data, null, 'content-type-json');
  }

  liveStandings(id, type, offset, limit, duration_id, game_id) {
    const url = `${environment.boxScoreUrl}/liveStandings/${id}/${type}/${offset}/${limit}/${duration_id}/${game_id}`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }

  getStandings(id, type, offset, limit,seasonId = 0) {
    let url = `${environment.boxScoreUrl}/contestStandings/${id}/${type}/${offset}/${limit}`;
    if(seasonId) url = url+"?season="+seasonId;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }

  getMyStandings(id, type, user_id,seasonId = 0) {
    let url = `${environment.boxScoreUrl}/myStandings/${user_id}/${id}/${type}`;
    if(seasonId) url = url+"?season="+seasonId;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }

  movePlayers(lgm_id, fl_id, player_in, player_out, user_id) {
    const url = `${environment.phpApiUrl}/swap/moveSwap/${environment.DRAFT_ACCESS_TOKEN}/${lgm_id}/${fl_id}/${player_in}/${player_out}/${user_id}`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }

  getWeekMatrix(lgm_id,game_id) {
    const url = `${environment.boxScoreUrl}/bestball/weekMatrix/${lgm_id}?game_id=${game_id}`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }
  
  trackMismatch(lgm_id) {
    const url = `${environment.phpApiUrl}/league/trackLogs/${environment.DRAFT_ACCESS_TOKEN}/${lgm_id}`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }  
  
  getContestInfo(lg_id) {
    const url = `${environment.boxScoreUrl}/getLeagueData/${lg_id}/0`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }
  
  getSeasonList(){
    const url = `${environment.boxScoreUrl}/api/front/getSeasonList`;
    return this._utilsService.getRequest(url, null, 'content-type-json');
  }
}